var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('top-menu'),_vm._v(" "),_c('div',{staticClass:"page-content"},[_c('left-menu'),_vm._v(" "),_c('div',{staticClass:"content-wrapper"},[_c('header-content'),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2),_vm._v(" "),_c('footer-content')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6148fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/web/AdminLayout.vue
// module id = null
// module chunks = 